import { Navigate } from 'react-router-dom';

const NoMatch = () => {
  return <Navigate to={'/'} />;
};

export default NoMatch;
